// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const ja: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': '遊び方',
  'howto.pieces.heading': 'パーツ',
  'howto.pieces.source': '光源',
  'howto.pieces.mirror': '鏡',
  'howto.pieces.switch': 'スイッチ',
  'howto.pieces.exit': '出口',
  'howto.pieces.wall': '壁',
  'howto.controls.heading': '操作',
  'howto.controls.clickSlot.line1': 'マスをクリック',
  'howto.controls.clickSlot.line2': '鏡を置く',
  'howto.controls.dragMirror.line1': '鏡をドラッグ',
  'howto.controls.dragMirror.line2': '回転',
  'howto.controls.rightClick.line1': '右クリック',
  'howto.controls.rightClick.line2': '鏡を取り外す',
  'howto.controls.hint': 'マウスホイール:1°ずつ微調整。   鏡をタップ:15°回転。',
  'howto.objective.line1': 'すべてのスイッチを照らすと、出口の鍵が開きます。',
  'howto.objective.line2': '次に出口をクリック。できるだけ少ない鏡で解いてください。',

  'howtoColor.title': '色とプリズム',
  'howtoColor.pieces.heading': '新しいパーツ',
  'howtoColor.pieces.prism': 'プリズム',
  'howtoColor.pieces.redSwitch': '赤いスイッチ',
  'howtoColor.pieces.yellowSwitch': '黄色いスイッチ',
  'howtoColor.pieces.whiteSwitch': '白いスイッチ',
  'howtoColor.how.heading': '仕組み',
  'howtoColor.how.line1': '白い光線は赤・緑・青の光を同時に運びます。',
  'howtoColor.how.line2': 'プリズムは白い光を三辺に沿って三本の色付き光線に分けます。',
  'howtoColor.how.line3': '置いたプリズムをクリックすると、入力面の向きを回転できます。',
  'howtoColor.switches.line1': 'スイッチには色付きのドットが表示されます — それが必要な色です。',
  'howtoColor.switches.line2':
    '黄色のスイッチ(赤 + 緑のドット)は両方の色が同時に届く必要があります。',
  'howtoColor.switches.line3': '白色のスイッチ(三色すべて)は赤・緑・青が同時に届く必要があります。',

  'options.hints.label': 'パズルでヒントの角度を表示',
  'options.hints.help': '反射するたびに、入射光線と反射光線の間の角度を表示します。',

  'level.01-intro.title': 'こんにちは、光',
  'level.02-two-mirrors.title': '二度のターン',
  'level.03-corner.title': '行く手の壁',
  'level.04-two-targets.title': '二つの的',
  'level.05-tight.title': '狭い',
  'level.06-hello-color.title': 'こんにちは、色',
  'level.07-pick-a-side.title': 'どちらかを選べ',
  'level.08-yellow.title': '黄',
  'level.09-magenta.title': 'マゼンタ',
  'level.10-spectrum.title': 'スペクトル',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': '直角',
  'puzzle.hint.angleType.acute': '鋭角',
  'puzzle.hint.angleType.obtuse': '鈍角',
  'puzzle.hint.label': '{angle}°\n{type}',
};
